import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined'
import FolderIcon from '@mui/icons-material/Folder'
import { Typography } from '@mui/material'
import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Stack from '@mui/material/Stack'
import ToggleButton from '@mui/material/ToggleButton'
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup'
import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { WrapperCenter } from '../../components/WrapperCenter'
import { useDiskStore } from '../../store/storeDisk'

export const FileMoveDialog = ({ open, handleClose, file }) => {
    const [searchParams] = useSearchParams()
    const [fileName, setFileName] = useState(undefined)
    const { moveFileOrFolder, fetchFolderList, folderList, isFetchFolderList } = useDiskStore(
        (state) => state,
    )

    useEffect(() => {
        fetchFolderList({
            exclude_prefix:
                file.object_type === 'folder' ? file.filename?.split(file.user_uuid).pop() : '',
        })
    }, [])

    const handleChange = (event, fileName: string) => {
        setFileName(fileName)
    }

    const handleSubmit = async () => {
        const folder = searchParams.get('folder') ?? '/'
        const prefix =
            file.object_type === 'folder'
                ? file.filename?.split(file.user_uuid).pop()
                : `/disk${folder}${file.filename}`
        const destination =
            file.object_type === 'folder'
                ? `${fileName.slice(file.user_uuid.length)}${file.filename?.slice(0, -1).split('/').pop()}/`
                : `${fileName.slice(file.user_uuid.length)}${file.filename?.split('/').pop()}`
        await moveFileOrFolder({
            prefix,
            destination,
        })
        handleClose()
    }

    const foldersToMove = (folderList ?? []).filter(({ filename }) => {
        const diskPath = filename.split('/').slice(1).join('/')

        return !file.prefix?.includes(`/${diskPath}${file.filename}`)
    })

    return (
        <>
            <Dialog
                PaperProps={{
                    style: {
                        width: '500px',
                    },
                }}
                open={open}
                onClose={handleClose}>
                <DialogTitle sx={{ mb: 0 }}>Переместить в папку</DialogTitle>
                <DialogContent>
                    {isFetchFolderList ? (
                        <WrapperCenter>
                            <CircularProgress />
                        </WrapperCenter>
                    ) : (
                        <>
                            {foldersToMove.length > 0 ? (
                                <>
                                    <Typography variant="h4">Перемещение объекта:</Typography>
                                    <Typography
                                        sx={{
                                            mb: 4,
                                        }}>
                                        {file.object_type === 'folder'
                                            ? file.filename?.slice(0, -1).split('/').pop()
                                            : file.filename?.split('/').pop()}
                                    </Typography>

                                    <ToggleButtonGroup
                                        sx={{ width: '100%' }}
                                        orientation="vertical"
                                        value={fileName}
                                        exclusive
                                        onChange={handleChange}>
                                        {foldersToMove.map((forder) => {
                                            const name = forder.filename
                                                ?.slice(0, -1)
                                                .split('disk')
                                                .pop()
                                                .slice(1)

                                            return (
                                                <ToggleButton
                                                    key={forder.filename}
                                                    value={forder.filename}>
                                                    <Stack
                                                        direction="row"
                                                        sx={{
                                                            justifyContent: 'space-between',
                                                            alignItems: 'center',
                                                            width: '100%',
                                                        }}>
                                                        <Stack
                                                            direction="row"
                                                            sx={{ alignItems: 'center' }}
                                                            spacing={2}>
                                                            <FolderIcon
                                                                sx={{
                                                                    color: '#004B9F',
                                                                    fontSize: '24px',
                                                                }}
                                                            />
                                                            <Stack
                                                                sx={{ alignItems: 'flex-start' }}>
                                                                <Typography
                                                                    variant="caption2"
                                                                    sx={{ color: '#121317' }}>
                                                                    {file.object_type ===
                                                                        'folder' && name === ''
                                                                        ? 'Мой диск'
                                                                        : name}
                                                                </Typography>
                                                                <Typography variant="caption2">
                                                                    {forder.total_count} объектов
                                                                </Typography>
                                                            </Stack>
                                                        </Stack>
                                                        <ArrowForwardIosOutlinedIcon
                                                            sx={{ fontSize: '20px' }}
                                                        />
                                                    </Stack>
                                                </ToggleButton>
                                            )
                                        })}
                                    </ToggleButtonGroup>
                                </>
                            ) : (
                                <Typography variant="caption2" sx={{ color: '#121317' }}>
                                    У вас нет папок
                                </Typography>
                            )}
                        </>
                    )}
                </DialogContent>

                <DialogActions>
                    <Button onClick={handleClose} variant="outlined">
                        Отменить
                    </Button>
                    <Button
                        onClick={handleSubmit}
                        variant="contained"
                        color="primary"
                        disabled={!fileName}>
                        Переместить
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
